// ✅ src/App.js (updated to use Navbar component)
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from './components/Dashboard';
import CreateStudyGroup from './components/CreateStudyGroup';
import StudyGroupDetails from './components/StudyGroupDetails';
import Signup from './components/Signup';
import Login from './components/Login';
import Logout from './components/Logout';
import Navbar from './components/Navbar';
import './App.css';

function App() {
  const token = localStorage.getItem("token");

  return (
    <Router>
      <Navbar />
      <div className="container">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/create" element={<CreateStudyGroup />} />
          <Route path="/group/:groupId" element={<StudyGroupDetails />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          {token && <Route path="/logout" element={<Logout />} />}
        </Routes>
      </div>
    </Router>
  );
}

export default App;